module.exports = __webpack_public_path__ + "static/img/servo_sg90-1.fd57ea9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/servo_sg90-1.svg
// module id = 8jBN
// module chunks = 0